import { Search } from "lucide-react";
import { STATUSES } from "@/lib/clients";

const selectCls = "border border-gray-300 rounded-sm px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#002FA7]";

export function ClientFilters({ search, setSearch, status, setStatus, tag, setTag, tags }) {
  return (
    <div className="flex flex-wrap gap-3 mb-5">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input data-testid="search-input" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search name, email, company…"
          className="w-full border border-gray-300 rounded-sm pl-9 pr-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
      </div>
      <select data-testid="status-filter" value={status} onChange={(e) => setStatus(e.target.value)} className={selectCls}>
        <option value="all">All statuses</option>
        {STATUSES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
      </select>
      <select data-testid="tag-filter" value={tag} onChange={(e) => setTag(e.target.value)} className={selectCls}>
        <option value="all">All tags</option>
        {tags.map((t) => <option key={t} value={t}>{t}</option>)}
      </select>
    </div>
  );
}
